import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import styled from 'styled-components'

import { VisibleScrollbarStyle } from '@/styles/scrollbar'

const StContent = styled.div`
  ${VisibleScrollbarStyle}
  grid-area: content;
  display: flex;
  flex-direction: column;
  overflow-y: auto;

  ${({ theme }) => `
    gap: ${theme.UI.SpacingPx.Space6};
  `}
`

const StDocumentList = styled.div`
  display: flex;
  flex-direction: column;
`

const StIcon = styled(FontAwesomeIcon)`
  width: 16px;
  height: 16px;
`

const StButtonContainer = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  padding: 0 ${({ theme }) => theme.UI.SpacingPx.Space4};
`

export { StButtonContainer, StContent, StDocumentList, StIcon }
